(function(){
  'use strict';

  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function getDrawer(){ return q('#nmCartDrawer'); }
  function getPanel(){ return q('#nmCartDrawer .nm-cart-drawer__panel'); }
  function getOverlay(){ return q('#nmCartDrawer .nm-cart-drawer__overlay'); }

  function clearLegacyCartConflicts(){
    qa('#AjaxifyDrawer.is-visible, #AjaxifyModal.is-visible, .ajaxcart__overlay').forEach(function(el){
      el.classList.remove('is-visible');
      el.style.display = 'none';
      el.style.opacity = '0';
      el.style.visibility = 'hidden';
      el.style.pointerEvents = 'none';
    });
    document.body.classList.remove('ajaxcart--is-visible', 'ajaxify-lock');
  }

  function cleanupForcedState(){
    var drawer = getDrawer();
    var panel = getPanel();
    var overlay = getOverlay();

    document.documentElement.classList.remove('nm-cart-open');
    document.body.classList.remove('nm-cart-open');

    if (drawer && !drawer.classList.contains('nm-open')) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.style.opacity = '';
      drawer.style.pointerEvents = '';
      drawer.style.visibility = '';
    }

    if (panel && (!drawer || !drawer.classList.contains('nm-open'))) {
      panel.style.transform = '';
      panel.style.webkitTransform = '';
      panel.style.opacity = '';
      panel.style.visibility = '';
      panel.style.pointerEvents = '';
      panel.style.display = '';
      panel.style.right = '';
      panel.style.zIndex = '';
    }

    if (overlay && (!drawer || !drawer.classList.contains('nm-open'))) {
      overlay.style.opacity = '';
      overlay.style.visibility = '';
      overlay.style.pointerEvents = '';
      overlay.style.zIndex = '';
    }
  }

  function hardenDrawerVisibility(){
    var drawer = getDrawer();
    var panel = getPanel();
    var overlay = getOverlay();
    if (!drawer || !panel) return;

    drawer.classList.add('nm-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.style.opacity = '1';
    drawer.style.pointerEvents = 'auto';
    drawer.style.visibility = 'visible';

    panel.style.transform = 'translateX(0)';
    panel.style.webkitTransform = 'translateX(0)';
    panel.style.opacity = '1';
    panel.style.visibility = 'visible';
    panel.style.pointerEvents = 'auto';
    panel.style.display = 'flex';
    panel.style.right = '0';
    panel.style.zIndex = '2';

    if (overlay) {
      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.pointerEvents = 'auto';
      overlay.style.zIndex = '1';
    }

    document.documentElement.classList.add('nm-cart-open');
    document.body.classList.add('nm-cart-open');
  }

  function robustOpenAndRefresh(){
    clearLegacyCartConflicts();

    if (window.nmCartDrawer && typeof window.nmCartDrawer.close === 'function') {
      try { window.nmCartDrawer.close(); } catch(e) {}
    }
    cleanupForcedState();

    setTimeout(function(){
      if (window.nmCartDrawer && typeof window.nmCartDrawer.open === 'function') {
        try { window.nmCartDrawer.open(); } catch(e) {}
      }
      hardenDrawerVisibility();
    }, 20);

    [90, 220, 420].forEach(function(delay){
      setTimeout(function(){
        hardenDrawerVisibility();
        if (window.nmCartDrawer && typeof window.nmCartDrawer.refresh === 'function') {
          try { window.nmCartDrawer.refresh(); } catch(e) {}
        }
      }, delay);
    });
  }

  document.addEventListener('nm:cart:added', robustOpenAndRefresh, true);

  document.addEventListener('click', function(e){
    var trigger = e.target && e.target.closest && e.target.closest('[data-nm-cart-trigger]');
    if (!trigger) return;
    setTimeout(function(){ hardenDrawerVisibility(); }, 40);
  }, true);

  document.addEventListener('click', function(e){
    var closeBtn = e.target && e.target.closest && e.target.closest('[data-nm-cart-close], #nmCartDrawer .nm-cart-drawer__overlay');
    if (!closeBtn) return;
    setTimeout(cleanupForcedState, 30);
    setTimeout(cleanupForcedState, 180);
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      setTimeout(cleanupForcedState, 30);
      setTimeout(cleanupForcedState, 180);
    }
  }, true);

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/i.test(action)) return;
    setTimeout(function(){
      if ((form.dataset && form.dataset.nmSubmitting === '1') || form.classList.contains('is-adding')) {
        clearLegacyCartConflicts();
      }
    }, 10);
  }, true);

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function(resp){
        if (resp && resp.ok && /\/cart\/(add|change|update)\.js(?:\?|$)/i.test(url)) {
          robustOpenAndRefresh();
        }
        return resp;
      });
    };
  }

  window.addEventListener('pageshow', cleanupForcedState);
  document.addEventListener('visibilitychange', function(){
    if (!document.hidden) cleanupForcedState();
  });
})();
